import { updateBannerSequenceApiCall } from "./../sources/BannerSource";
import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  fetchBannersApiCall,
  updateBannerApiCall,
  updateBannerProductsApiCall,
} from "../sources/BannerSource";
import {
  IBannersResponseNormalized,
  IUpdateBannerPayload,
  IUploadImageResponse,
} from "../../interfaces/banner.interface";
import { IActionType } from "../../interfaces/Index";
import { uploadImageApiCall } from "utils/UploadImage";
import { normalizeCatchErrors } from "utils/errorUtils";

export const fetchBannersInit = () => ({
  type: actionTypes.GET_BANNERS_INIT,
});

export const fetchBannersSuccess = (payload: IBannersResponseNormalized[]) => ({
  type: actionTypes.GET_BANNERS_SUCCESS,
  payload,
});

export const fetchBannersFail = (error: string | object | null) => ({
  type: actionTypes.GET_BANNERS_FAIL,
  error,
});

export const updateBannerInit = () => ({
  type: actionTypes.UPDATE_BANNER_INIT,
});

export const updateBannerSuccess = (payload: IBannersResponseNormalized) => ({
  type: actionTypes.UPDATE_BANNER_SUCCESS,
  payload,
});

export const updateBannerFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_BANNER_FAIL,
  error,
});

export const updateBannerAndProductsInit = () => ({
  type: actionTypes.UPDATE_BANNER_AND_PRODUCT_INIT,
});

export const updateBannerAndProductsSuccess = () => ({
  type: actionTypes.UPDATE_BANNER_AND_PRODUCT_SUCCESS,
});

export const updateBannerAndProductsFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_BANNER_AND_PRODUCT_FAIL,
  error,
});

export const updateBannerSequenceInit = () => ({
  type: actionTypes.UPDATE_BANNER_SEQUENCE_INIT,
});

export const updateBannerSequenceSuccess = () => ({
  type: actionTypes.UPDATE_BANNER_SEQUENCE_SUCCESS,
});

export const updateBannerSequenceFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_BANNER_SEQUENCE_FAIL,
  error,
});

// async actions
export const getBanners =
  (cityId: string, customerChannel: string) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchBannersInit());
    return fetchBannersApiCall(cityId, customerChannel)
      .then((data: IBannersResponseNormalized[]) =>
        dispatch(fetchBannersSuccess(data))
      )
      .catch((e: object | null | string) => dispatch(fetchBannersFail(e)));
  };

export const uploadBannerImageAction =
  (imgPayload: FormData, desktopImagePayload: FormData) =>
  async (dispatch: Dispatch<IActionType>): Promise<void> => {
    dispatch(updateBannerAndProductsInit());

    try {
      // first image upload

      if (imgPayload.get("image")) {
        await uploadImageApiCall("banner", imgPayload);
      }

      if (desktopImagePayload.get("image")) {
        await uploadImageApiCall("banner", desktopImagePayload);
      }

      dispatch(updateBannerAndProductsSuccess());
    } catch (e: any) {
      dispatch(updateBannerAndProductsFail(e));
    }
  };

export const uploadImageAndUpdateBannerAndProducts =
  (
    imgPayload: FormData,
    w2000Xh375FormData: FormData,
    bannerPayload: IUpdateBannerPayload,
    bannerProductPayload: any
  ) =>
  async (dispatch: Dispatch<IActionType>) => {
    let mobileImage: IUploadImageResponse;
    let desktopImage: IUploadImageResponse;

    if (imgPayload.get("image")) {
      mobileImage = await uploadImageApiCall("banner", imgPayload);
      bannerPayload.bannerImages = {
        w400Xh400: mobileImage?.id || bannerPayload.bannerImages.w400Xh400,
        w2000Xh375: bannerPayload.bannerImages.w2000Xh375,
      };

      bannerPayload.imageId =
        mobileImage?.id || bannerPayload.bannerImages.w400Xh400;
    }

    if (w2000Xh375FormData.get("image")) {
      desktopImage = await uploadImageApiCall("banner", w2000Xh375FormData);
      bannerPayload.bannerImages = {
        w400Xh400: bannerPayload.bannerImages.w400Xh400,
        w2000Xh375: desktopImage?.id || bannerPayload.bannerImages.w2000Xh375,
      };
    }

    return updateBannerAndProducts(
      bannerPayload,
      bannerProductPayload
    )(dispatch);
  };

export const updateBannerAndProducts =
  (bannerPayload: IUpdateBannerPayload, bannerProductPayload: any) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(updateBannerAndProductsInit());
    return updateBannerApiCall(bannerPayload)
      .then((bannerResponse: IBannersResponseNormalized) =>
        updateBannerProductsApiCall(bannerResponse.id, bannerProductPayload)
      )
      .then(() => dispatch(updateBannerAndProductsSuccess()))
      .catch((e: object | null | string) =>
        dispatch(updateBannerAndProductsFail(e))
      );
  };

export const updateBanner =
  (bannerPayload: IUpdateBannerPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(updateBannerInit());
    return updateBannerApiCall(bannerPayload)
      .then((bannerResponse: IBannersResponseNormalized) =>
        dispatch(updateBannerSuccess(bannerResponse))
      )
      .catch((e: object | null | string) => dispatch(updateBannerFail(e)));
  };

export const updateBannerSequence =
  (cityId: string, bannerIds: string[]) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(updateBannerSequenceInit());
    return updateBannerSequenceApiCall(cityId, bannerIds)
      .then(() => {
        dispatch(updateBannerSequenceSuccess());
      })
      .catch((e: object | null | string) => {
        dispatch(updateBannerSequenceFail(e));
      });
  };
